import { render, staticRenderFns } from "./combos.vue?vue&type=template&id=50490e12"
import script from "./combos.vue?vue&type=script&lang=js"
export * from "./combos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports